"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _settings = require("../../utils/settings");

var _EmojiPickerPopover = _interopRequireDefault(require("../EmojiPickerPopover"));

var _hsSettings = require("../../constants/hsSettings");

var EmojiToolbarButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(EmojiToolbarButton, _Component);

  function EmojiToolbarButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmojiToolbarButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EmojiToolbarButton).call(this, props));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMouseEnter = _this.handleMouseEnter.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRemove = _this.handleRemove.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInsertEmoji = _this.handleInsertEmoji.bind((0, _assertThisInitialized2.default)(_this));
    _this.togglePopover = _this.togglePopover.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isPopoverOpen: false,
      EmojiPicker: (0, _settings.getPickerComponent)(props.editor, 'EmojiPicker')
    };
    return _this;
  }

  (0, _createClass2.default)(EmojiToolbarButton, [{
    key: "togglePopover",
    value: function togglePopover() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        shouldOpen: true
      },
          shouldOpen = _ref.shouldOpen;

      this.setState({
        isPopoverOpen: shouldOpen
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          editor = _this$props.editor,
          trackOnOpen = _this$props.trackOnOpen,
          initEmojiStore = _this$props.initEmojiStore;
      var isPopoverOpen = this.state.isPopoverOpen;

      if (isPopoverOpen) {
        this.togglePopover({
          shouldOpen: false
        });
      } else {
        trackOnOpen();

        if (editor.settings[_hsSettings.HS_INPAGE]) {
          initEmojiStore(this.togglePopover);
        } else {
          this.togglePopover();
        }
      }
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      var EmojiPicker = this.state.EmojiPicker;
      EmojiPicker.preload();
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      var isPopoverOpen = this.state.isPopoverOpen;

      if (isPopoverOpen) {
        this.setState({
          isPopoverOpen: false
        });
      }
    }
  }, {
    key: "handleInsertEmoji",
    value: function handleInsertEmoji(emoji) {
      var editor = this.props.editor;
      editor.execCommand('hsInsertEmoji', false, emoji.native);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          editor = _this$props2.editor,
          storeHandlers = _this$props2.storeHandlers;
      var _this$state = this.state,
          isPopoverOpen = _this$state.isPopoverOpen,
          EmojiPicker = _this$state.EmojiPicker;
      return _react.default.createElement(_EmojiPickerPopover.default, {
        isOpen: isPopoverOpen,
        editor: editor,
        onRemove: this.handleRemove,
        onInsertEmoji: this.handleInsertEmoji,
        storeHandlers: storeHandlers,
        EmojiPicker: EmojiPicker
      }, this.props.renderButton(this.handleClick, this.handleMouseEnter, isPopoverOpen));
    }
  }]);
  return EmojiToolbarButton;
}(_react.Component);

exports.default = EmojiToolbarButton;
EmojiToolbarButton.propTypes = {
  editor: _react.PropTypes.object.isRequired,
  trackOnOpen: _react.PropTypes.func.isRequired,
  storeHandlers: _react.PropTypes.shape({
    getter: _react.PropTypes.func,
    setter: _react.PropTypes.func
  }),
  initEmojiStore: _react.PropTypes.func,
  renderButton: _react.PropTypes.func.isRequired
};
module.exports = exports.default;